import date_parse from 'locutus/php/datetime/date_parse'
import mktime from 'locutus/php/datetime/mktime'

class Event {
	constructor(event) {
		//utc offset 1h
		try {
			let utc_offset = 0

			//bind events
			//let date_raw = event.date_start
			//let end_date_raw = event.fieldEventDate.endDate.split(' ')

			this.id = event.eventId
			this.url = event.url
			this.ts = parseInt(event.dateStart)

			this.dateobj = new Date((this.ts + utc_offset) * 1000)

			this.end_ts = parseInt(event.dateEnd)
			if(!this.end_ts) {
				this.end_ts = this.ts;
			}

			this.end_dateobj = new Date((this.end_ts + utc_offset) * 1000)
			this.timezone = this.end_dateobj.getTimezoneOffset() * 60

			this.time_start = event.timeStart
			this.time_end = event.timeEnd

			this.teaser = event.teaser
			this.title = event.eventTitle
			this.subtitle = event.subtitle
			this.booked_out = event.bookedOut
			this.closed = event.closed

			if (event.events_topic) {
				this.events_topic = event.eventsTopic
			}

			if (event.events_type) {
				this.events_type = event.eventsType
			}

			if (event.events_series) {
				this.events_series = event.eventsSeries
			}

			if (event.image) {
				this.image = event.image
			}

		} catch (e) {
			console.log(e)
		}
	}
}

export {Event}
